import isEmpty from 'lodash/isEmpty'
import type { ChatMessageProps } from '../chatComponents'

// A non-public message carrying an `externalId` arrived by email and is held for an agent's
// release, never a staff note — `AddChatInternalNote` writes a note with none
// (libs/chat/node/src/actions/AddChatInternalNote.ts:51-63).
export const isInternalNoteMessage = ({
  isPublic,
  externalId,
}: Pick<ChatMessageProps, 'isPublic' | 'externalId'>): boolean => isPublic === false && isEmpty(externalId)
